import React from 'react';

import { CareRecipient } from '~support-at-home/models/careRecipients';

import TruncatedCell from './TruncatedCell';

interface ComponentProps {
  row: CareRecipient;
}

const nameOf = (name: string | null | undefined) => name || 'Unnamed client';

// The "TurnPoint client" column. Matched and Unlinked rows name the client holding the Medicare Ref.
// (with Disabled when that client is disabled), Suggested rows show the proposal in muted text, and
// Conflict rows count the clients, naming them on hover. Every case stays on one line.
const CareRecipientClientCell: React.FC<ComponentProps> = ({ row }) => {
  const { match_status: status, linked_client: linked, suggested_client: suggested } = row;

  if ((status === 'matched' || status === 'unlinked') && linked) {
    const text = linked.disabled ? `${nameOf(linked.client_name)} (Disabled)` : nameOf(linked.client_name);
    return <TruncatedCell text={text} dataCy={`sah-care-recipient-client-${row.id}`} />;
  }

  if (status === 'suggested' && suggested) {
    return (
      <TruncatedCell
        text={`Suggested: ${nameOf(suggested.client_name)}`}
        className="text-muted"
        dataCy={`sah-care-recipient-client-${row.id}`}
      />
    );
  }

  if (status === 'conflict') {
    const clients = row.conflict_clients ?? [];
    const names = clients.map((c) => nameOf(c.client_name)).join(', ');
    return (
      <span
        className="sah-care-recipient-text"
        title={names || undefined}
        data-cy={`sah-care-recipient-client-${row.id}`}
      >
        {clients.length} clients
      </span>
    );
  }

  return <span className="text-muted">-</span>;
};

export default CareRecipientClientCell;
